import axios from 'axios';

const setting = {
  timeout: 300000,
};

//token이 필요없는 request에서 사용
export const instance = axios.create(setting);
